import * as FileSaver from 'file-saver';

export const saveAsExcelFile = (buffer: any, fileName: any) => {
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';
    const data = new Blob([buffer], {
        type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
};

export const exportExcel = (data:any) => {   
    import('xlsx').then((xlsx: any) => {
        const worksheet = xlsx.utils.json_to_sheet(data);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        const fileName = data?.length > 1 ? data[1]['Scorecard Name']+'_'+data[1]['Performance Period'] : 'ExportHistory';
        saveAsExcelFile(excelBuffer, fileName);
    });
};